import React from 'react'
import CashZoneButton from '../CashZoneButton'

const mobileFilterBtnData = [
    {
        "link_href": "#",
        "label": "슈퍼사다리1분"
    },
    {
        "link_href": "#",
        "label": "슈퍼사다리3분"
    },
    {
        "link_href": "#",
        "label": "슈퍼사다리5분"
    },
    {
        "link_href": "#",
        "label": "슈퍼로하이1분"
    },
    {
        "link_href": "#",
        "label": "슈퍼로하이3분"
    },
    {
        "link_href": "#",
        "label": "슈퍼로하이5분"
    },
    {
        "link_href": "#",
        "label": "슈퍼섯다"
    },
    {
        "link_href": "#",
        "label": "로터스홀짝"
    },
    {
        "link_href": "#",
        "label": "로터스바카라"
    },
    {
        "link_href": "#",
        "label": "가상축구"
    },
    {
        "link_href": "#",
        "label": "개경주"
    },
    {
        "link_href": "#",
        "label": "경마"
    }
]
const BettingPageFilteFields = () => {
    return (
        <>
            <div className='grid lg:hidden grid-cols-3 p-0.5 gap-1.5'>
                {mobileFilterBtnData.map((item, index) => (

                    <div className="" key={index}>
                        <a href={item.link_href} className='font-Serif font-bold bg-deep-blue text-center w-full h-7 leading-7 text-xs inline-block text-white shadow-[inset_2px_2px_3px_rgb(255_255_255_/_30%),inset_-2px_-2px_3px_rgb(0_0_0_/_20%)] mx-px rounded-[5px] border border-[#132d9a]'>{item.label}</a>
                    </div>
                ))}
            </div>
            <div className="text-white pb-2.5 text-xs font-sans-serif w-fit ms-auto hidden lg:block">
                <strong>경기선택</strong>
                <select name="bt_type" className='ms-1 border text-white text-xs h-[38px] leading-[38px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-[5px] border-solid border-slate bg-obsidian outline-none lg:focus:border-indigoBlue focus:border-[#ffcc00]' >
                    <option value="">전체</option>
                    <option value="591">슈퍼사다리1분</option>
                    <option value="592">슈퍼사다리3분</option>
                    <option value="593">슈퍼사다리5분</option>
                    <option value="594">슈퍼로하이1분</option >

                    <option value="595" > 슈퍼로하이3분</option >
                    <option value="596" > 슈퍼로하이5분</option >
                    <option value="597" > 슈퍼섯다</option >
                    <option value="71" > 로터스홀짝</option >

                    <option value="83" > 로터스바카라</option >
                    <option value="13" > 가상축구</option >
                    <option value="14" > 개경주</option >
                    <option value="116" > 경마</option >
                </select >
                &nbsp;
                <strong>&nbsp;기간선택</strong>
                <input type="text" name="bt_regist_s" size="11" value="2025-04-25" className='mx-1 border text-white text-xs leading-[38px] h-[38px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-[5px] border-solid border-slate bg-obsidian outline-none lg:focus:border-indigoBlue focus:border-[#ffcc00]' />
                ~
                <input type="text" name="bt_regist_e" size="11" value="2025-05-02" className='mx-1 border text-white text-xs leading-[38px] h-[38px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-[5px] border-solid border-slate bg-obsidian outline-none lg:focus:border-indigoBlue focus:border-[#ffcc00]' />
                <CashZoneButton label="검색" link_src="#" active_color="bg-amberGold" active={true} type="button" />
            </div>
        </>
    )
}

export default BettingPageFilteFields